module.exports = __webpack_public_path__ + "img/happy.ab1cd5e8.png";